import React from "react";
import { useTable, useExpanded } from "react-table";
import classNames from "classnames";
import PaginationNav from "../Pagination/Pagination";
// import Pagination from "@mui/material/Pagination";
// import { useRouter } from "next/router";
// import SpinnerOverlay from "../../atoms/spinner-overlay/spinner-overlay";

const Table = ({
  columns,
  data,
  isLoading,
  renderSubComponent,
  getRowProps,
  fullHeight = false,
  pagination = true,
  total,
  pageSize = 50,
  pageCount,
  className,
  currentPage,
  onPageChange,
}) => {
//   const history = useRouter();
//   const { page } = history.query;
  const shouldShowPagination =
    pagination && total && currentPage && typeof onPageChange === "function";
  const totalPages = shouldShowPagination
    ? Math.max(1, pageCount || Math.ceil(total / pageSize))
    : 1;
  const tableInstance = useTable({ columns, data }, useExpanded);
  // console.log("tablr")

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    tableInstance;

  return (
    // apply the table props
    <div>
      <div
        className={classNames(
          `overflow-auto h-viewport   relative`,
          className
        )}
        style={{ height: '75vh' }} // Adjust the height as needed
      >
        {/* {isLoading && <SpinnerOverlay className="rounded" />} */}
        <table
          {...getTableProps()}
          className="w-full table-auto bg-white border-collapse"
        >
          <thead className="border-b">
            {
              // Loop over the header rows
              headerGroups.map((headerGroup) => {
                const { key, ...headerGroupProps } = headerGroup.getHeaderGroupProps();

                return (
                  // Apply the header row props
                  <tr key={key} {...headerGroupProps} >
                    {
                      // Loop over the headers in each row
                      headerGroup.headers.map((column) => {
                        const { key: columnKey, ...headerProps } = column.getHeaderProps();

                        return (
                          // Apply the header cell props
                          <th
                            key={columnKey}
                            {...headerProps}
                            className="px-2 py-4 font-bold uppercase text-xs text-white sticky top-0 z-10 bg-bgBlue text-center"
                          >
                            {
                              // Render the header
                              column.render("Header")
                            }
                          </th>
                        );
                      })
                    }
                  </tr>
                );
              })
            }
          </thead>

          {/* Apply the table body props */}
          <tbody {...getTableBodyProps()}>
            {
              // Loop over the table rows
              rows.map((row) => {
                // Prepare the row for display
                prepareRow(row);
                const rowProps = getRowProps
                  ? row.getRowProps(getRowProps(row))
                  : row.getRowProps();
                const { key, ...safeRowProps } = rowProps;
                return (
                  // Apply the row props
                  <React.Fragment key={key}>
                    <tr
                      {...safeRowProps}
                      className="hover:bg-gray-100 border-b border-dashed"
                    >
                      {
                        // Loop over the rows cells
                        row.cells.map((cell) => {
                          // Apply the cell props
                          const { key: cellKey, ...cellProps } = cell.getCellProps();

                          return (
                            <td
                              key={cellKey}
                              {...cellProps}
                              className="px-2 py-2 text-sm text-center max-w-xs break-words"
                            >
                              {
                                // Render the cell contents
                                cell.render("Cell", {
                                  row: {
                                    ...row,
                                    canExpand: !!renderSubComponent,
                                  },
                                })
                              }
                            </td>
                          );
                        })
                      }
                    </tr>
                    {row.isExpanded &&
                      renderSubComponent &&
                      renderSubComponent({ row, rowProps })}
                  </React.Fragment>
                );
              })
            }
          </tbody>
        </table>
      </div>
      {shouldShowPagination && (
        <div className="flex justify-center mt-4">
          <PaginationNav
            pageIndex={currentPage}
            pageCount={totalPages}
            onPageChange={onPageChange}
          />
        </div>
      )}
      {/* {pagination && (
        <Pagination
          className="m-4 float-right"
          count={totalPages}
          color="primary"
          page={parseInt(page) || 1}
          onChange={(e, page) => {
            history.push({
              pathname: history.pathname,
              query: { ...history.query, page },
            });
          }}
        />
      )} */}
    </div>
  );
};

export default Table;
